let info = {
  name: "Jaydip Barvaliya",
  logo_name: "Jaydip",
  flat_picture: require("./src/assets/potrait.jpg"),
  config: {
    use_cookies: true,
    navbar: {
      blur: false
    }
  },
  description:
    "I define myself as a Full Stack Developer who also harvest AWS Cloud!. Always curious to learn and discuss technology. I have proficiency in different Back-End & Front-End Technologies, Frameworks and have worked a lot on them as well as on provisioning Infrastructure as Code.",
  links: {
    linkedin: "https://www.linkedin.com/in/jaydip-barvaliya/",
    github: "https://github.com/JaydipBarvaliya",
    resume: "https://github.com/JaydipBarvaliya/Resume/blob/main/Jaydip_Resume.pdf"
  },
  education: [
    {
      name: "St. Clair College",
      place: "Toronto, Canada",
      date: "May, 2021 - Aug, 2022",
      degree: "Data Analytics For Business",
      gpa: "3.9/4.0",
      description:"",
      skills: [
        "Data Structure",
        "Algorithms",
        "System Design"
      ]
    },
    {
      name: "Parul University",
      course:"Information & Technology",
      place: "Gujarat, India",
      date: "Apr, 2014 - Apr, 2018",
      degree: "Bachelor Of Engineering",
      gpa: "8.0/9",
      description:"",
      skills: [
        "OOP",
        "MYSQL",
        "Github",
        "Bit of C/C++",
        "HTML",
        "CSS"
      ]
    }
  ],
  experience: [

    {
      name: "Cognizant",
      place: "Mississauga, Canada",
      position: "Sr. Software Engineer I",
      date: "Aug, 2022 - Present",      
      description:"",
      skills: [
        "Leadership",
        "Tech Lead",
        "Cloud Architect",
        "Terraform",
        "Production Handler"
      ]
    },
    {
      name: "Sunflower Lab",
      place: "Gujarat, India",
      position: "DevOps Engineer",
      date: "Dec 2020 - Oct 2021",      
      description:"",
      skills: [
        "Jenkins",
        "Ansible",
        "AWS",
        "GrayLog"
      ]
    },
    {
      name: "Advanced",
      place: "Gujarat, India",
      position: "Full Stack Developer",
      date: "Jun 2018 - Dec 2020",      
      description:"",
      skills: [
        "Spring Boot",
        "Spring Security",
        "Hibernate",
        "JPA",
        "REST",
        "REST Docs",
        "JUnit",
        "Maven",
        "PostGreSQL",
        "VueJS",
        "NodeJs",
        "Mosaic"
      ]
    },
    {
      name: "STL - Sterlite Technologies",
      place: "Gujarat, India",
      position: "Jr. Software Engineer",
      date: "Jan 2018 - Jun 2018",      
      description:"",
      skills: [
        "Core Java",
        "Shell Scripting",
        "Support"
      ]
    }
  ],
  skills: [
    {
      title: "Languages",
      info: [
        "Java"
      ],
      icon: "fa fa-code"
    },
    {
      title: "Frameworks",
      info: [
        "REST",
        "Spring-Boot",
        "Hibernate",
        "JPA",
        "Spring Security",
        "Maven",
        "JUnit"

      ],
      icon: "fa fa-cubes"
    },
    {
      title: "Web Technologies",
      info: ["Vue.js", "React.js", "Node.js", "HTML", "CSS"],
      icon: "fas fa-laptop-code"
    },
  
    {
      title: "AWS Cloud",
      info: ["EC2", "Lambda", "S3", "VPC", "DynamoDB", "Route 53",  "API Gateway", "CloudFront", "ECS", "SNS", "SQS"],
      icon: "fa fa-cloud"
    },

    {
      title: "Databases",
      info: ["MySQL", "PostGreSQL",],
      icon: "fa fa-database"
    },


    {
      title: "DevOps Tools",
      info: [
        "Terraform",
        "Jenkins",
        "Docker"
      ],
      icon: "fas fa-tools"
    },

    {
      title: "",
      info: [
      ],
      icon: ""
    },

    {
      title: "Other",
      info: [
        "NIFI",
        "Keycloak"
      ],
      icon: "fa fa-feather"
    },

    {
      title: "",
      info: [
      ],
      icon: ""
    },

  ],
  certificates: [

    {
      name: "AWS Certified Developer - Architect",
      pictures: [
        {
          img: require("./src/assets/certificates/architect/Architect.png")
        }
      ],
      technologies: [],
      category: "",
      // github: "https://github.com/Jaydip/todo-application",
      visit: "https://www.credly.com/badges/9c5423d1-c31c-44f8-9405-6d199d6ebc8d",
      description:""
    },

    {
      name: "AWS Certified Developer Associate ",
      pictures: [
        {
          img: require("./src/assets/certificates/developer/developer.png")
        }
      ],
      technologies: [],
      category: "",
      github: "https://github.com/Jaydip/grocery-listing-react",
      date: "",
      visit: "https://www.credly.com/badges/3e34cf1d-0ab1-4a79-9397-b213ed80bfde",
      description:  "",
    }
  ],
   recommendations: [

    {
      title:"Jaydip and I put our first step in the IT industry together at OneAdvanced. However, within a short span of time Jaydip had gained tons of technical insight, and his learning and grasping ability can definitely make anyone jaw-dropped. He had joined advanced as a Developer. Nevertheless, he molded himself in a way that he was single handly managing the projects without any hassle even it requires full-stack or DevOps stuff. I would definitely recommend him for any IT industry because learning with little effort can be an asset for any company.",
      author: "Karan Patel",
      position: "Quality Assurance Engineer",
      company: "Amazon",
      location: "California, United States"
    },

    {
      title:"Jaydip is a knowledgeable, dedicated and most of all helpful team member. Not only were his skills invaluable to the team but his approachability and pleasant demeanor were a boost to team morale. He is highly recommended for any roles within his qualification.",
      author: "Parthiv Barot",
      position: "Test Manager",
      company: "IBM",
      location: "Nova Scotia, Canada"
    },
    
    {
      title:"Jaydip is an excellent, fast gripping technical resource. He has good adaptive approaches to cope up with new technologies at ease. As well as he is down to earth by his behaviour all the time. I am happy to recommend him at any type of corporate working environment and skills.",
      author: "Koushik Ghosh",
      position: "Back End Engineer",
      company: "realworld one",
      location: "Germany"
    },
    
    {
      title:"Extremely curious person with unbelievable degree to learn new stuff and excel in no time that's how I would describe Jaydip. I'd definitely recommend him to any firm because he has got really demonstrable capabilities which goes well beyond his CV.",
      author: "Pratik Sheth",
      position: "Cloud Architect",
      company: "Pathlock",
      location: "Bengaluru, Karnataka, India"
    },
    
    {
      title:"Energetic, Creative and Explorer are the words which describe Jaydip the best. He is always ready for the job which is presented to him and always finding ways to make it more efficient based on his knowledge.. In my experience of working with Jaydip for almost 2 years I never saw him troubled for any task assigned as he always had the confidence to do it. His quick actions in resolving issues is a thing to note. He is a quick learner and was working with some of the best minds of the organisation in no time after being part of the team. I still remember the project where we had to recreate a legacy product on cloud and Jaydip played a key role to make the work look effortless. His cheerful nature and wit is something I will always miss around office.",
      author: "Rishabh Sharma",
      position: "Senior Test Engineer",
      company: "Advanced",
      location: "Vadodara, Gujarat, India"
    },
    
    {
      title:"I had the pleasure of working with Jaydip in the same team over multiple projects. He is an excellent teammate and passionate about his work. He is a very keen learner which supports his agility to blend in the company's work and culture. Jaydip would be a valuable asset to any company.",
      author: "Priyal Jadav",
      position: "CloudOps Analyst",
      company: "PMC Retail",
      location: "Vadodara, Gujarat, India"
    },
    
    {
      title:"Jaydip is passionate about writing code and solving clients problems through the development of creative and innovative software. He has tremendous potential. He is vocal about his software ideas, but respects his superiors and enthusiastically tackles every assignment as he is directed. He is friendly, easy to get along with, well-liked by our clients and respected by his co-workers.",
      author: "Barkha Jha",
      position: "Test Analyst",
      company: "Infosys",
      location: "Pune, Maharashtra, India"
    },
    
    {
      title:"Although Jaydip joined my team as a fresher, he immediately demonstrated a remarkable ability of learning new things very quickly. His problem solving skills are really good. His ability to work on different areas like backend, frontend as well as DevOps makes him an asset to any team. Highly recommended to work for any team.",
      author: "Prem Rawal",
      position: "Senior Staff Software Architect",
      company: "infoDesk",
      location: "Vadodara, Gujarat, India"
    },

    {
      title:"He's a bright student who is always eager to learn, and I mostly found him immersed in technical activities, learning new and complex systems. He has the ability to persuade the public through the use of facts. Jaydip comes highly recommended by me as a software engineer.",
      author: "Dr. Savita Seharawat",
      position: "Data Scientist",
      company: "York Region",
      location: "Toronto, Canada"
    },
    
    {
      title:"Jaydip is a brilliant student who I taught, working hard and smart. He shows ability to manage difficult task in group-wise, creative manner.",
      author: "Yanjie(Vicky) Tao",
      position: "Instructor",
      company: "St.Clair College",
      location: "Toronto, Canada"
    },
    
    {
      title:"Rarely do postgraduate students come with as much drive as Jaydip. When he was a second year student, he took two of my Healthcare and Project Management classes. During that time, I was impressed by his ability to connect topics covered in class with both case studies and of-the-minutes answers. The way he grasps any new technical jargon in his field is really impressive. I would really recommend him to any tech giant.",
      author: "Matt Mostofi",
      position: "Data Scientist ",
      company: "Georgian@ILAC",
      location: "Toronto, Canada"
    },
    
    {
      title:"Jaydip Barvaliya, whom I have known as an undergraduate student of Information Technology engineering since his 1st academic year in my capacity as his Professor, Seminar supervisor, and project guide. During this time, he had consistently exhibited a high degree of dedication towards his academic curriculum. He is one of the most creative, intelligent and capable individuals.",
      author: "Nileshkumar Kakade",
      position: "Senior Technical Trainer",
      company: "SmartCliff",
      location: "Tamil Nadu, India"
    },
    
    {
      title:"Any organization would be lucky to have Jaydip as their Engineer. This is the person who has become for me an ideal for learning area and any tech stack like Frontend, Backend, DevOps, even at he is really proficient at Data Structure & Algorithm & Problem solving.",
      author: "Brijesh Kalathiya",
      position: "DevOps Engineer",
      company: "Maruti Techlabs",
      location: "Ahmedabad, Gujarat, India"
    },
    
    {
      title:"We are not in same industry, but since school time I know him. The way he think when it comes to technical perspective that's lit. He always learn, love and endorse computer jargons. He has been mentoring for technical ideas, various projects, geeky notions to tons of people and some of them are his seniors, also. I'm proud of having him in best friend list like Jaydip. His wit nature can make any tough work environment easy. He will be great asset for any needed company.",
      author: "Raj Monpara",
      position: "Derivatives Analyst",
      company: "Jainam Share Consultants Pvt. Ltd",
      location: "Surat, Gujarat, India"
    },
    
    {
      title:"Jaydip is very hardworking and extremely talented individuals. he is very good Software development and also has lot of technical background and master of algorithms.",
      author: "Dhaval Parmar",
      position: "Senior Software Engineer",
      company: "Azilen Technologies",
      location: "Ahmedabad, Gujarat, India"
    },
    
    {
      title:"I rarely come across real talents who stand out like Jaydip. Dedicated, Good listener, Hardworking, Good Learning appetite are the attributes one will observe while working with him, I had the pleasure of working with Jaydip, I highly recommend and wish him a great career ahead.",
      author: "Himanshu Chaudhari",
      position: "Senior Database Administrator",
      company: "Advanced",
      location: "Vadodara, Gujarat, India"
    },
    
    {
      title:"Jaydip is a very dedicated and workaholic guy who strives for continuous improvement in his work and skill sets, He is a great team player, He manages any tasks given to him very well, He thinks quickly on his feet and that is one of the best qualities he has.",
      author: "Rajni Barvaliya",
      position: "Sr. Coldfusion Developer",
      company: "iSummation Technologies Pvt Ltd",
      location: "Ahmedabad, Gujarat, India"
    },
    
    {
      title:"I have worked with Jaydip during my OneAdvance tenure. He is one of the sharpest minds I have come across. He is objective and result oriented. He has a good grasp on both technical and business domains and innovates solutions rather than following the flow. He takes ownership in each of the project activity. He is definitely a great asset which any company would want!",
      author: "Parth Lunagariya",
      position: "Senior Software Engineer",
      company: "Advanced",
      location: "Vadodara, Gujarat, India"
    },
    
    {
      title:"Jaydip is enthusiastic and always ready to work on challenging tasks. He is very good at AWS and Java Stack Technologies.",
      author: "Nishat Lakhani",
      position: "Full Stack Java Developer",
      company: "InfoBeans",
      location: "Vadodara, Gujarat, India"
    },
    
    {
      title:"I rarely come across real abilities who persist out like Jaydip. Jaydip is really good at technical thinking. The way he thinks and measures the solution for any problem in a short time-frame that really amazing. We were not work in the same company but as far as I know him he can learn anything within a really shorter period of time and that things are really amazing for any company. I definitely recommend him.",
      author: "Raj Patel",
      position: "Relationship Manager",
      company: "Vashi Integrated Solutions Ltd",
      location: "Gujarat, India"
    },
    
    {
      title:"Jaydip has gained a lot of skills in a short amount of time. He is a technology enthusiast and a geek. He is a fine addition to any team he works for.",
      author: "Jalaj Shukla",
      position: "Senior Software Engineer",
      company: "Xoriant",
      location: "Ahmedabad, Gujarat, India"
    },
    
    {
      title:"Jaydeep started his career with me. I remember how he was curious to learn during the training. He is such a talented software developer that he can do any task within the timeline. He is always hungry to learn new technology. He is very spontaneous and dedicated towards his work.he does his duty like he is doing that for himself. I personally like him because of his talent and friendly in nature and most important he is always ready to help his colleagues.there is no question that he can be an asset for any IT company.",
      author: "Ramiz Siddique",
      position: "Sr QA Engineer",
      company: "LoudCloud Systems Inc",
      location: "Maharashtra, India"
    },
    
    {
      title:"Data Annotator, not less than any professional - Good communicator - Punctual - Dedicated to working. On the matter of completing the job, crosses expectations",
      author: "Aneri Manvar",
      position: "Web Developer",
      company: "Windowmaker Software Ltd",
      location: "Vadodara, Gujarat, India"
    },
    
    {
      title:"Jaydip has the perfect combination of skills that makes him a good software engineer and even better team member. He has good grasping over various aspect like UI, Back-end and even at Cloud tech stack. Jaydip always be ready to learn new stack and managing tasks within a timeline. The way he is working is amazing. I definitely recommend him.",
      author: "Hemal Prajapati",
      position: "Principal Software Engineer",
      company: "Advanced",
      location: "Vadodara, Gujarat, India"
    },
    
    {
      title:"Jaydip is an extremely talented guy. He has really strong technical fundamentals. he is hardworking as well geek with good communication skills. he is good team player.",
      author: "Pratik Barot",
      position: "Software Engineer",
      company: "Lowe's India",
      location: "Banglore, India"
    },
    
    {
      title:"I know Jaydip since University, He is a very intelligent and hardworking techy guy. He is persistent while attempting to solve complex technical problems. Apart from technicality, he is really good at leadership. He is someone who can be relied upon to get the job done and his advice always been fruitful for me in adverse times.",
      author: "Sapan Digaswala",
      position: "Senior Technical Engineer",
      company: "UPL",
      location: "Anklesvar, Gujarat, India"
    },
    
    {
      title:"It is rare that you come across a loving personality like Jaydip Barvaliya. I have known him since last 4 Years. He has transformed himself from a regular developer to a brilliant DevOps Engineer. He is the first person to contact for any advice. Apart from Coding he love to play Guitar and whenever he do, he transform the environment into Wonderland. He is a vey productive, broad-minded and forward thinking individual. His desire for excellence makes him winner in whichever work he do. Working with Jaydip is a signature of success.",
      author: "Piyush Vaghela",
      position: "Human Resource Manager",
      company: "Collabera",
      location: "Vadodara, Gujarat, India"
    },
     
    {
      title:"Jaydip works for excellence. His integrity and energy are at the core of everything he does. He is a quick learner, a good communicator, and a team player. His experience is profound and his actions are impactful at everything he does. a true techy guy who knows most of the aspect of software development from UI to Cloud",
      author: "Raj Kothiya",
      position: "Freelance Android Developer",
      company: "Freelancer",
      location: "Surat, Gujarat, India"
    },
     
    {
      title:"Jaydip is having a friendly and happy nature with very good IT knowledge and skills. He does his work with passion and since he likes IT industry , so for Jaydip work is not work , it's fun for him. Jaydip will never let you down in work as he is very good at it since College times. Good luck Jaydip.",
      author: "Abhee Sheth",
      position: "Technology Analyst",
      company: "Infosys",
      location: "Bengaluru, Karnataka, India"
    }
    ]
};

export default info;



